/**
 * (c) 2009-2014 Demandware Inc. Subject to standard usage terms and conditions
 * For all details and documentation:
 * https://bitbucket.com/demandware/sitegenesis
 */
'use strict';

var header = require('./components/header'),
    countries = require('./countries'),
    dialog = require('./dialog'),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    searchplaceholder = require('./searchplaceholder'),
    searchsuggest = require('./searchsuggest'),
    tooltip = require('./tooltip'),
    util = require('./util'),
    login = require('./login'),
    validator = require('./validator'),
    contentAssetHelper = require('./contentassethelper'),
    ajax = require('./ajax'),
    tls = require('./tls'),
    tealium = require('../../../int_tealium/cartridge/js/tealium/tealium'),
    lookbook = require('./lookbook'),
    search = require('./pages/search'),
    quickview = require('./quickview'),
    formFields = require('./components/formFields'),
    productTile = require('./product-tile'),
    smsOptInModal = require('../../../int_vibes/cartridge/js/smsoptinmodal'),
    internationalShipping = require('./internationalshipping');

window.quickview = quickview;
window.productTile = productTile;
window.internationalShipping = internationalShipping;
// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');
    s.setAttribute('src',
        'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');
    document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
require('./captcha')();
require('./spc').init();
function initializeEvents() {
    var $window = $(window);
    if($(window).width() < 1024){
       var potentialBrokenListParents = $('.menu-category.level-1').find('.nav-column.col-2.level-3.show-only-mobile.show-categories');
       $(potentialBrokenListParents).each(function() {
            var diffClass = $(this).attr('class').split(' ').pop();
            if($('.' + diffClass + ':not(.show-categories)').length && $('.' + diffClass + ':not(.show-categories)').children().length){
                $('.' + diffClass + ':not(.show-categories)').children().clone().appendTo('.nav-column.col-2.level-3.show-only-mobile.show-categories.' + diffClass);
                $('.' + diffClass + ':not(.show-categories)').remove();
            }		
        });
    }
    else{
        $('.menu-category.level-1 > li > a.has-sub-menu').attr('aria-expanded','false').attr('aria-haspopup','true');
    }        
    $('.no-flyout > a').removeClass('has-sub-menu');
    var hasSeenRebuttalMessage = false;
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
    util.updateInputFields();    

    var lastBreadCrumb = $(".breadcrumb").find("*:visible").last();
    $(lastBreadCrumb).on("click", function () {
        $(this).focus();
    });

    $('footer,#main,.content-banner-breadcrumb').click(function(e){
    	if( !$(e.target).is('.user-panel') && !$(e.target).closest('.user-panel').length > 0 ) {
    		$('body').find('.DelayHover').removeClass('DelayHover');
    	}
    });

    $(document).on('keydown', function(){
        window.lastClickOrKey = 'key';
    }).on('mousedown',function(){
        window.lastClickOrKey = 'click';
    });
    
    $window.on('load resize', function(e){
        //6209 - Sort By Dropdown focus issue fixed for ipad//
    	if($window.width() > 767 && $window.width() < 1024){
    		$('.sort-by').attr('tabindex', '0');
	    } else {
	    	$('.sort-by').removeAttr('tabindex');
        }

        var $nanobar = $('#nanobar-container.nano-desktop > div');
        var $stickySort = $('.ws-sticky.refinements');
        
        if ($nanobar.length && $stickySort.length) {
            var nanobarHeight = $nanobar.height();
            var stickyNavHeight = ($window.width() < 1024) ? $('.fixed-header-wrapper').height() : $('.header-mian-banner').height();

            if (stickyNavHeight > 66) {
                stickyNavHeight = 66;
            }
            var top = (nanobarHeight + stickyNavHeight) - 1;
            $stickySort.css({ top: top });
        }
		if($(".refinements.ws-sticky").length){
            $(".refinements.ws-sticky").removeAttr("style");
        }        
    });
    
    $('body').on('keyup','.sort-by', function(e){
    	window.sortByOpen = false;
    	if($(window).width() > 767 && $(window).width() < 1024){
	    	var selectedLiIndex = $(this).find("li.selected").prevAll("li").length;
	    	switch(e.keyCode){
	    		case 38:
	    			$(this).find("li").eq(selectedLiIndex > 0 ? (selectedLiIndex - 1) : ($(this).find("li").length - 1)).siblings("li").removeClass("selected").end().addClass("selected").trigger("click");
	    			window.sortByOpen = true;
	    			$(this).addClass("focus-outline current_item").focus().find("li.selected").addClass("focus-outline");
	    		break;
	    		case 40:
	    			$(this).find("li").eq(selectedLiIndex == ($(this).find("li").length - 1) ? 0 : (selectedLiIndex + 1)).siblings("li").removeClass("selected").end().addClass("selected").trigger("click");
	    			window.sortByOpen = true;
	    			$(this).addClass("focus-outline current_item").focus().find("li.selected").addClass("focus-outline");
	    		break;
	    		case 13:
	    			$(this).find('.selected-option').trigger('click');
	    		break;
	    	}    
    	}
    }).on("click", function(e){
    	window.sortByOpen = false;
    });
    // WCAG - Secondary Navigation - keyboard focus - mini cart flyout

    


    // WCAG - Quick-view button accessibility starts
    $('body').on('keyup', '.grid-tile', function(e){
        if(e.shiftKey && e.keyCode === 9 && !$(this).find('.product-swatches').length){
            if($(this).find('.quickview').length && !$(this).find('.quickview.active').length){
                $(this).find('.quickview').addClass('active').focus().addClass('focus-outline');;
            }
        }
        else if(e.keyCode === 9){
            e.preventDefault();
            if($(this).find('.quickview').length && !$(this).find('.quickview.active').length){
                $(this).find('.quickview').addClass('active');
            }
        }
    }).on('blur', '.grid-tile', function (e) {
        e.preventDefault();
        var $elem = $(this);
        setTimeout(function () {
            if (!$elem.find(':focus').length) {
                $elem.find('.quickview').removeClass('active');
            }
        }, 0);
    });

    $('body').on('keypress','div.ui-dialog.quick-view button.ui-dialog-titlebar-close, div.ui-dialog.minicartpopup.cart-overlay button.ui-dialog-titlebar-close', function(e){
        if(e.keyCode === 13){
            setTimeout(function(){
                if ($('a.quickview[data-returnfocus="true"]').length){
                $('a.quickview[data-returnfocus="true"]').addClass('active');
                $('a.quickview[data-returnfocus="true"]').first().focus().addClass('focus-outline');
                $('a.quickview[data-returnfocus="true"]').attr('data-returnfocus','false');                
            }},0);
        }
    });

    // WCAG - Quick-view button accessibility ends

    // For small devices, removed focus on my bag link
    $(window).on("load resize", function () {
        if (window.innerWidth <= 767) {
            $('.shopping-bag-sm').removeClass('flyout-cart');
        }
        else if($('.shopping-bag-sm').find('.ucp2-cart-with-item-icon').length){
            $('.shopping-bag-sm').addClass('flyout-cart');
        }
        // mini cart flyout should not open on cart page only
        $('.pt_cart .shopping-bag-sm, .pt_cart_template_b .shopping-bag-sm').removeClass('flyout-cart');
    });

    // WCAG - PDP - keyboard focus - color swatches for enter key click event
    $('body').on('keypress', '.swatch', function(e){
        if(e.keyCode == '13'){
            $(this).trigger('click');
        }
    });
    
    /* WCAG_Modal_focus_management */
    $(document).on("dialogopen", ".ui-dialog", function(){
        setTimeout(function(){
             $('.ui-dialog').focus();
        }, 500);
        $('body').on('keypress', '.ui-dialog', function(e){
            if(e.keyCode == 9){
                $('.ui-dialog .ui-dialog-titlebar-close').attr('tabindex','0');
                $('.ui-dialog .ui-dialog-titlebar-close').focus().addClass('focus-outline');
                $("body").off('keypress', '.ui-dialog');
            }
        });
    });

    // WCAG - cart - keyboard focus - for enter key click event
    $('body').on('keypress', '.shippingoverlay-link', function(e){
        if(e.keyCode == '13'){
            $(this).trigger('click');
        }
    });

    // WCAG - PDP - thumnail selection - keyboard focus - for enter key click event
    $("body").on("keypress",".thumbnail-link",function(e){
        if(e.keyCode == '13'){
            e.preventDefault();
            $(this).closest('.slick-slide').find('.productthumbnail').trigger('click');
        }
    });
    
    $(window).load(function() {
    	if($('.login-box-content.returning-customers').length>0 && $('.returning-customers .invalid-email').length>0 && $('.returning-customers .customerFound').length>0 && $('.returning-customers .customerFound').val()=='true'){
    		localStorage.setItem('emailSubmitted',$('.create-login .login-box-content.returning-customers .input-text.email.required.email').val());
    	} else if($('.login-box-content.returning-customers').length>0 && $('.returning-customers .invalid-email').length>0 && $('.returning-customers .customerFound').length>0 && $('.returning-customers .customerFound').val()!='true') {
    		localStorage.removeItem('emailSubmitted');
    	}else if($('.resetpassword').length>0 && $('#PasswordResetForm').find('input[type="text"]').length>0 && localStorage.getItem('emailSubmitted') !=null){
    		$('.resetpassword #PasswordResetForm').find('input[type="text"]').val(localStorage.getItem('emailSubmitted'));
    		localStorage.removeItem('emailSubmitted');
    	}else{
    		localStorage.removeItem('emailSubmitted');
        }
        //paypal validation for address fields not more than 30 characters on page load
    	//SC-7652 Fixed the console issue which prevent to trigger the click event for wrire a review button on PDP. Since IE does not support window Native URL 
    	 var params = util.getQueryStringParams(window.location.href);
         var paypalError = params.addressError;
         var expressBillingError = params.billingError;
         if(paypalError === 'true'){
             $('#secondary').find('.rightbutton').trigger('click');
         }
         if(expressBillingError === 'true'){
             $('#primary').find('.editaddress').trigger('click');
             $('#secondary').find('.rightbutton').trigger('click');
         }
          //open default form with errors (address line 1 & 2 length check) on clicking my account -> addresses
        if($('.address-list-sec').hasClass('editDefaultAddress')){
            $('.address-edit.default-address').trigger('click');
            $('.apply-button').trigger('click');
        }
        if(SitePreferences.GLOBALE_ENABLED && SitePreferences.GLOBALE_IS_PHASE2){
            if($('body').find('.slider-menu .globale-country-selector')){
                var elemToAppend = '<div class="footer-globale-country-selector">'+
                                '<div class="footer-heading">'+Resources.GLOBALE_CONTAINER_HEADING+'</div>'+
                                '<ul><li><div class="current-country"><a href="javascript:void(0);" role="button" class="globale-selector"></a>'
                                '</li></ul></div></div>';
                $('.footer_list_wrapper').find('.footer_item:last-child').append(elemToAppend);
                $('body').find('.footer-globale-country-selector .globale-selector').html($('body').find('.slider-menu .globale-country-selector .globale-selector').html());
            }
            $('.footer_list_wrapper').find('.footer-globale-country-selector .globale-selector').on('click',function(){
                gle("ShippingSwitcher","show");
            });
        }else{
            $(".footer-globale-country-selector").hide();
        }
    });

    // WCAG - wishlist - keyboard focus - for enter key click event
    $('body').on('keypress', '.copy-link', function(e){
        if(e.keyCode == '13'){
            $(this).trigger('click');
            $(this).focus().addClass('focus-outline');
        }
    });
    // WCAG - keyboard focus spacebar checkbox
    $('body').on('keypress', '.wishlist-columns .public .input-checkbox', function(e){
        if(e.keyCode == '32'){
            $(this).trigger('change');
            $(this).focus().addClass('focus-outline');
        }
    });

     ///open respective forms with errors (address line 1 & 2 length check) on changing non-default address to default address
     $('body').off('click','.address-make-default').on('click','.address-make-default', function (e) {
        var addressLine1 = $(this).closest('.address-list-sec').find('.addressLine1');
        var addressLine2 = $(this).closest('.address-list-sec').find('.addressLine2');
        if($(addressLine1).text().length > 30 || $(addressLine2).text().length > 30){
            e.preventDefault();
            $(this).next('.address-edit').trigger('click');
            $('.apply-button').trigger('click');
        }
    });

    $('body').on('keydown', 'textarea[data-character-limit]', function (e) {
        var text = $.trim($(this).val()),
            charsLimit = $(this).data('character-limit'),
            charsUsed = text.length;

        if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
            e.preventDefault();
        }
    }).on('change keyup mouseup', 'textarea[data-character-limit]', function () {
        var text = $(this).val(),
            charsLimit = $(this).data('character-limit'),
            charsUsed = text.length,
            charsRemain = charsLimit - charsUsed;

        var $container =  $(this).siblings('.char-count');

        if (charsRemain < 0) {
            $(this).val(text.slice(0, charsRemain));
            charsRemain = 0;
        }

        if (charsRemain == 0) {
            $container.find('.char-remain-count').hide();
            $container.find('.char-count-text').text(' ' + Resources.CHARACTER_LIMIT_REACHED);
        } else {
            $container.find('.char-remain-count').text(charsRemain).show();
            $container.find('.char-count-text').text(' ' + Resources.CHAR_LIMIT_MSG);
        }
    });
    /**
     * Validate user input and allow only digits and hyphen.
     *
    **/
    $('body').off('change input', '.allow-only-digit-hyphen').on('change input', '.allow-only-digit-hyphen', function (e) {
    	var $this = $(this);
    	$this.val(this.value.replace(/[^\d-]/g, ''));
    });
    /**
     * Validate user input and allow only digits.
     *
     **/
    $('body').off('change input', '.allow-only-digit').on('change input', '.allow-only-digit', function (e) {
    	var $this = $(this);
		$this.val(this.value.replace(/[^\d]/g, ''));
    });


    $('body').on('click', '.gift-cardlookup-balance', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var cardLookUpUrl = form.attr('action');
        form.validate();
        if (!form.valid()) {
            return false;
        }
        ajax.load({
            url: cardLookUpUrl,
            method: 'POST',
            data: form.serialize(),
            callback: function (data) {
                var responseVal = $(data).filter('input[name="checkbalance-result"]').val();
                if (responseVal === "true") {
                    $('.gift-card-lookup-results').removeClass('hide');
                    $('.gift-card-lookup-section').addClass("hide");
                    $('.svs-card-balance').text($(data).filter('.checkbalance-balance').text().trim());
                    $('.svs-masked-number').text($(data).filter('.checkbalance-number').text().trim());
                    $(".giftcard-lookup-error").addClass("hide");
                } else {
                    $(".giftcard-lookup-error").removeClass("hide");
                }
            }
        });
    });

    $('body').on('click', '.another-card, .check-balance-link', function (e) {
        $('.gift-card-lookup-results').addClass('hide');
        $('.gift-card-lookup-section').removeClass("hide");
        $('#gift-check-balance-form').trigger('reset');
    });

    /** script to hide gift card brand specific */
    if (siteInfo.brandContextID) {
        $('.card_brand_' + siteInfo.brandContextID).hide();
    }

    /**
     * initialize search suggestions, pending the value of the site
     * preference(enhancedSearchSuggestions) this will either init the
     * legacy(false) or the beta versions(true) of the the search suggest
     * feature.
     */
    var $searchContainer = $('.header-search');
    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);
    
    var $searchField = $('.simpleSearch input#q');
    var $searchFieldCloseIcon = $('.header-search .simplesearch').find('form button.close-icon');
    $searchField.on("keyup",function (e) {
    	if (($searchField.val() == '' && e.keyCode == 8) || (e.ctrlKey && e.keyCode == 88)){
    		$searchFieldCloseIcon.addClass('hide-mobile');
    	} else {
    		$searchFieldCloseIcon.removeClass('hide-mobile');
    		if (!$($searchField).val()) {
    			$searchFieldCloseIcon.addClass('hide-mobile');
    		}
    	}
    });
    $searchField.on("click",function (e) {
        if (!$($searchField).val()) {
            $searchFieldCloseIcon.addClass('hide-mobile');
        }
    });
    $searchFieldCloseIcon.on("click",function (e) {
        $searchFieldCloseIcon.addClass('hide-mobile');
        $($searchField).val('');
    });

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    if ($('.showcontent').length > 0) {
        $('.toggle').next('.toggle-content').show();
        $('.toggle').attr("aria-expanded", "true");
    }
    else {
        $('.toggle').next('.toggle-content').hide();
        $('.toggle').attr("aria-expanded", "false");
    }
    $(document).off('click keypress', '.toggle').on('click keypress', '.toggle', function (e) {
        if( !e.isTrigger && e.which != 1 && e.which != 13 ){
            return;
        }
        //billing tabs handled seperatly
        if (!$('#wrapper').hasClass('pt_product-search-result') || $('#wrapper').hasClass('quick-order-page')) {
            $(this).toggleClass('expanded').next('.toggle-content').slideToggle();
            $(this).attr('aria-expanded', $(this).attr('aria-expanded') === "true" ? "false" : "true");
        }
    });

    //Billing page tabs
    $(document).on("focus", ".checkout-body .edit-link:first", function(e) {
        $("html, body").animate({ scrollTop: 0 }, "fast");
    });

    $(document).on('click keypress', '.row-header', function (e) {
        if( !e.isTrigger && e.which != 1 && e.which != 13 ){
            return;
        }
        e.preventDefault();
        if ($(e.target).closest('a.option-tooltip').length == 0) {
        	if($(this).closest('.tab-section').find('.toggle-content').hasClass('deferactive')){
        		$(this).closest('.tab-section').find('.toggle-content').slideToggle('fast', function() {
        		    if ($(this).is(':visible'))
        		        $(this).css('display','flex');
        		});
        	}else{
        		$(this).closest('.tab-section').find('.toggle-content').slideToggle('medium', function() {
        		    if ($(this).is(':visible'))
        		        $(this).css('display','block');
        		});
        	}
            $(this).find('.arrow-img').toggleClass('expanded');
            $(this).find('.arrow-img').attr("aria-expanded", $(this).find('.arrow-img').hasClass('expanded')? 'true' : 'false'); 
        }
    });

    if ($('.billing-coupon-code ').is(':visible')) {
        $('.showcontent').find('.toggle').addClass('expanded');
    }
    if($('.order-detail-section').length){
        $('.order-detail-section').find('.view-more-link').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.order-detail-section').find('.expanded-section').toggle();
            if (!$(this).hasClass('opened')) {
                ;
                $(this).addClass('opened').text('View Less');
                $(this).closest('.order-detail-section').addClass('expanded-order').find('.total').addClass('total-expanded');
            } else {
                $(this).removeClass('opened').text('View Details');
                $(this).closest('.order-detail-section').removeClass('expanded-order').find('.total').removeClass('total-expanded');
            }
        });
    }

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            var val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({
                color: '#999999'
            }, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT).css('color',
                '#999999').animate({
                    color: '#333333'
                }, 500, 'linear');
        });
    }   
    
    
    window.onkeydown = function(e) {
    	if($('.email-popup').length==0 || $('.email-popup').hasClass('hide')){
    		return;
    	}
    	if(!$('.email-popup #content-popup').hasClass('hide')){
    		var focusableElements=document.querySelectorAll('.email-popup #content-popup a,.email-popup #content-popup input,.email-popup #content-popup button');
    	}else{
    		var focusableElements=document.querySelectorAll('.email-popup #success-email-international a,.email-popup #success-email-international input,.email-popup #success-email-international button');
    	}
    	
        var firstFocusableEl=focusableElements[0],
        lastFocusableEl=focusableElements[focusableElements.length-1],
        KEY_TAB = 9,
        KEY_ESC = 27;
        
	    function handleBackwardTab() {
			if ( document.activeElement === firstFocusableEl ) {
				e.preventDefault();
				lastFocusableEl.focus();
			}
		}
		function handleForwardTab() {
			if ( document.activeElement === lastFocusableEl ) {
				e.preventDefault();
				firstFocusableEl.focus();
			}
		}
		
		switch(e.keyCode) {
			case KEY_TAB: 
				if ( e.shiftKey ) {
					handleBackwardTab();
				} else {
					handleForwardTab();
				}
				break;
			case KEY_ESC:
				$('.email-popup [aria-label="close"]').triggerHandler('click');
				break;
			default:
				break;
		} // end switch		
    };
    
    //Pop-Up
        
    if($('.email-popup').length){
        $('.email-popup').on("click", function(e){
            if (e.target.id == "content-popup" || $(e.target).parents("#content-popup").length) {
                return;
            } else {
                $('.email-popup [aria-label="close"]').triggerHandler('click');
            }
        }); 
        
        $('.email-popup [aria-label="close"]').on("click", function(){
            $( '.email-popup' ).addClass( 'hide' );
        });     

        $('.email-popup input[type="email"]').on('click',function(){
            $(this).attr("placeholder", "Email Address");
        });
        
        $('.email-popup form').on('submit',function (e) {	
        var emailID=$('body').find('.email-popup form input[type="email"]');
        var emailIdValidation= /^([\w\.\-\+])+\@(((\w[\-\w]*\.)+([a-zA-Z]{2,6}))|(\[{0,1}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\]{0,1}))$/;
        var isValid = emailIdValidation.test(emailID.val());
        if(!isValid){
            setTimeout(() => {
                emailID.attr("placeholder", "Invalid Email Address");
                emailID.val(" ");
                emailID.focus();
                emailID.addClass('error');
                $('body').find('.email-popup form span.error').hide();
            }, 0);
            return false;
        }
        
        var targetURL = Urls.subscribePopUP;
        var ppForm = this;
        var form = new FormData(ppForm);
        ajax.fetchData({
            url: targetURL,
            method: 'POST',
            data: form,
            callback: function (result) {
                if (!result.success) {
                    return false;
                } else {
                    $('#success-email-international').removeClass('hide');
                    $('#content-popup').addClass('hide');
                }
            }
        });
        e.preventDefault();
        return false;
        });
    }
    if($('.edit-profile').length){
        $('.edit-profile').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.profile-summary').slideUp();
            $(this).closest('.login-box-right-content').find('.show-profile').slideDown();
        });
    }

    // main menu toggle
    var NavHeight, MenuUtility, windowHeight, windowWidth, $menuUtility;
    NavHeight = $('#navigation').outerHeight();
    MenuUtility = $('.menu-utility-user').outerHeight();
    windowHeight = $(window).height();
    windowWidth = $(window).width();
    $menuUtility = $('.menu-utility').find('.menu-utility-user').outerHeight();
    $(window).resize(function () {
        windowHeight = $(window).height();
        if ($(window).width() <= 767 || $(window).width() >= 1024) {
            $('.header-promo-bottom').removeAttr('style');
        }
        $(".new-mega-menu").attr( 'data-heightCalc','false'); //SC-3513 new mega menu
        newMegaMenu($(".fixed-header").height(),true); //SC-3513 new mega menu calling
    });

    if ($(window).width() <= 767) {
        $('.order-number').on('click', function () {
            $(this).closest('.order-list').toggleClass('opened');
            $(this).closest('.order-list').find('.oh-buttons').slideToggle('slow');
        });
    }
    
    // PLP
    if($('.two-space-tile').length){
        $("<li></li>").insertAfter('.two-space-tile');
    }

    var scrollTimer; //Limit how often the scroll event fires
    $(window).on('load scroll resize', function (e) {
        var evt = e;
        if(typeof scrollTimer !== "undefined"){
            clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(function() {
			var top = $(window).scrollTop();
            var topBannerTop;
            if($('.top-banner').offset()){
                topBannerTop = $('.top-banner').offset().top;
            }             
            var headerTop = $('#header').offset().top;
            var nanoBarHeight = $('#header').offset().top - ($(".header-promo-banner #sfcc-nanobar-container").hasClass("sticky") ? 0 : $(".header-promo-banner #sfcc-nanobar-container").height());
            var countrySelectorHeight = $(".header-country-selector-container") && !$(".header-country-selector-container").hasClass('hide') && ($(window).width() > 1023) ? $(".header-country-selector-container").find('.country-sel-inn-row').height() : 0 ;
            if(top > topBannerTop-nanoBarHeight) {
                $('body').addClass('header-sticky-desktop');
                $('.header-mian-banner').css('top',nanoBarHeight);
                if($(window).width() < 1024 ) {
                    var headerOffsetTop = document.querySelector('#header').getBoundingClientRect().top;
                    if(headerOffsetTop > 0 ){                            
                        $('.header-mian-banner').css('height',$(window).height() - headerOffsetTop+'px');
                        $('.header-mian-banner').css('top',headerOffsetTop);
                    }else {
                        $('.header-mian-banner').css('top',0);
                    }
                }
            } else {
                $('body').removeClass('header-sticky-desktop');
                if(evt.type === "resize"){
                    $('.header-mian-banner').removeAttr("style");
                }
            }
            if(top > headerTop + $('.fixed-header').first().height()-66) {
                $('body').addClass('header-sticky-mobile');
            } else {
                $('body').removeClass('header-sticky-mobile');
            }
            if(nanoBarHeight > 0) {
                $('.fixed-header-wrapper').css('top',nanoBarHeight);
				if($(".refinements.ws-sticky").length && $(window).width() > 1023){
                    $(".refinements.ws-sticky").css("top", $(".header-promo-banner").height() + $(".slider-menu").height());
                }
            }
            if(countrySelectorHeight > 0){
                $('.fixed-header-wrapper').css('top',countrySelectorHeight);
                $('.header-mian-banner').css('top',countrySelectorHeight);              
				if($(".refinements.ws-sticky").length && $(window).width() > 1023){
                    $(".refinements.ws-sticky").css("top", countrySelectorHeight + $(".slider-menu").height());
                }
            }
            if($(".header-country-selector-container") && !$(".header-country-selector-container").hasClass('hide') && $(window).width() < 1024){
                $('.fixed-header-wrapper').css('top','0');
            }
            app.initLazyLoadImages();
		}, 100);
    });

    
    // Header Redesign - accordion with plus and minus for the brands menu
    if($(".expand-menu").length){
        $(".expand-menu").on("click", function(){
            $("body").toggleClass('brand-banner-expand-active');
            if($('body').hasClass('brand-banner-expand-active')){
                var top = $('.menu-utility').first().height();
                if($(window).width() < 768){
                    top += $('.nanobar-offer-container').first().height();
                    top += $('.header-promo-banner').first().find("#sfcc-nanobar-container").hasClass("sticky") ? $('.header-promo-banner').first().height() : 0;
                }
                $('.brand-menu').css('top', top).css('height',  $(window).height()-top);
                $(window).on("resize.brandBanner",(function() {
                    var resizeTop = $('.menu-utility').first().height();
                    if($(window).width() < 768){
                        resizeTop += $('.nanobar-offer-container').first().height();
                        resizeTop += $('.header-promo-banner').first().find("#sfcc-nanobar-container").hasClass("sticky") ? $('.header-promo-banner').first().height() : 0;
                    }
                    $('.brand-menu').css('top', resizeTop).css('height',  $(window).height()-resizeTop);
                }));
            } else {
                $(window).off("resize.brandBanner");
            }

            $(this).toggleClass('expand');
            toggleRightPanel('none');
        });
    }

    //Click on cross icon in search clears the search suggestion div

    //Handling click of review bag button on minicart flyout for SC-5325
    $(document).off('click touchend', 'a.button.mini-cart-link-cart').on('click touchend', 'a.button.mini-cart-link-cart', function (e) {
        e.preventDefault();
        var link = $(this).attr('href');
        window.location.href = link;
        return false;
    });

    //Hover on Navigation search should hidden
    $('#navigation').find('.level-1 > li').hover(function () {
        if ($('#search-suggestions').is(':visible') > 0 && $(window).width() > 1023) {
            $('.header-secondary .header-search').removeClass('active');
            $('#search-suggestions').hide();
        }
    });
    
  //SC-4934 mobile and Tablet Hamburger Menu issue//
    $("body").on("touchstart", ".has-sub-menu-level2-heading a, .has-sub-menu-parent-level3 a, .-parent-level3 a, .parent-level3 a, .parent-level4 a, .level-1 .level-2 .banner section a, .has-sub-menu-level3-heading,.has-sub-menu-level3", function(e){
	if($(window).width() > 1023 && $(this).attr("href")){
			 window.location = $(this).attr("href");
		 }
	 });

    /* Start: First Click on L1 on touch devices opens up dropdown and second click redirects to href link (SC-7855) */
     $("body").on("touchstart", ".menu-category.level-1 > li > a.has-sub-menu", function(e){
        if($(window).width() > 1023){
            if($(this).parent().hasClass("hoverIntent")){
                $(this).attr("data-touch-redirect-ready","true");
            }
            $(this).attr("data-event-from-touch-device","true");
        }
     });
     $("body").on("touchend", ".menu-category.level-1 > li > a.has-sub-menu", function(e){
        if($(window).width() > 1023){
            if($(this).attr("data-touch-redirect-ready") === "true"){  
                e.preventDefault();               
                $(this).removeAttr("data-touch-redirect-ready");
                window.location=$(this).attr('href');
            }
        }
     });
    /* End: First Click on L1 on touch devices opens up dropdown and second click redirects to href link (SC-7855) */

    
    //Click on cross icon in search clears the search suggestion div
    $('.header-search .simplesearch .close-icon').on('click', function () {
    	if($('.header-search').hasClass('active')){
    		 $('.header-secondary .header-search').removeClass('active');
             $('#search-suggestions').hide();
    	}
    });
    
    // Customer Service utility menu flyout - live chat conditional styling
    if($('.customer-service-info').length){
        $('.customer-service-info').on('mouseenter', function () {
            var $livechatcontainer = $(this).find('.livechat-icon');
            if ($livechatcontainer.find('.content-asset a img').attr('src')) {
                var boldChatLoaded = $livechatcontainer.find('.content-asset a img').attr('src').indexOf('boldchat.com') > -1 ? false : true;
                if (boldChatLoaded && !$livechatcontainer.hasClass('boldchat-loaded'))
                    $livechatcontainer.addClass('boldchat-loaded');
            }
        });
    }

    // Customer Service footer menu - live chat conditional styling
    $('.top-banner .menu-toggle').on('click', function (e) {
        e.preventDefault();
        var $livechatcontainer = $('.menu-footer .livechat-icon');
        if ($livechatcontainer.find('.content-asset a img').attr('src')) {
            var boldChatLoaded = $livechatcontainer.find('.content-asset a img').attr('src').indexOf('boldchat.com') > -1 ? false : true;
            if (boldChatLoaded && !$livechatcontainer.hasClass('boldchat-loaded'))
                $livechatcontainer.addClass('boldchat-loaded');
        }
    });

    // search in mobile
    $('.headermainsearch').off('click').on('click', function () {
        $(this).next('.header-secondary').toggleClass('active');
    });

    $('.search-button').off('click').on('click', function () {
        $(this).closest('.header-search').addClass('expand');
    });

    //search in sticky header
    $('.header-search button').on("click", function () {
        return header.validateSearchField();
    });

    //search button in search result page
    if($(".no-hits-search").length || $(".category-search").length){
        $('.no-hits-search, .category-search').find('button').on("click", function () {
            if ($('.no-hits-search, .category-search').find('input[type="text"]').val() == '' || $('.no-hits-search, .category-search').find('input[type="text"]').val() === $(this).closest('.no-hits-search, .category-search').find('input[type="text"]').attr('placeholder')) {
                return false;
            }
            return true;
        });
    }

    function resetMobileNav() {
        $('body').removeClass('header-mobile-menu-open').removeClass('right-panel-open');      
        $('#header .menu-category').removeClass('header-mobile-menu-l2-open').removeClass('header-mobile-menu-l3-open');
        $('.l2-activate').removeClass('l2-activate');
        $('.l2-active').removeClass('l2-active');
        $('.l3-activate').removeClass('l3-activate');
        $('.l3-active').removeClass('l3-active');
        $('.l3-active-child').removeClass('l3-active-child');
        $('.l2-disabled').removeClass('l2-disabled');
        $('.l3-disabled').removeClass('l3-disabled');
        $('.l4-active').removeClass('l4-active');
        $('.header-mian-banner').css('height','');
        $('.header-mian-banner').css('top','');
    }

    $('.menu-toggle').on("click", function (e) {
        e.preventDefault();
        if(!$('body').hasClass('header-mobile-menu-open')) {            
            $('body').addClass('header-mobile-menu-open');
            $('.navigation-scroll-inner').focus();                       
            var nanoBarHeight = $(window).width() < 768 ? document.querySelector('#header .menu-utility .brands-header > ul').getBoundingClientRect().top : document.querySelector('#header .menu-utility').getBoundingClientRect().top;
            if(nanoBarHeight > 0 && !$('body').hasClass('header-sticky-mobile')) {
                $('.header-mian-banner').css('height', $(window).height() - nanoBarHeight+'px');
                $('.header-mian-banner').css('top',nanoBarHeight);
            } else {
                $('.header-mian-banner').css('height','');
                $('.header-mian-banner').css('top','');
            }
            if($('body').hasClass('header-sticky-mobile')) {
                $('.header-mian-banner').css('top',$('.fixed-header-wrapper').position().top);
            }
            if($('.custom-megamenu').length && !$('.custom-megamenu').attr('data-menu-loaded') && SitePreferences.CUSTOM_HAMBURGER_MENU_PREF.enableAjax && SitePreferences.CUSTOM_HAMBURGER_MENU_PREF.enableCustomMenu){
	               mobileMenuLoad();
            }
            if($(window).width() < 768 && util.isIOS()){
                $('html, body').addClass('iosScrollStopper');
                $('.navigation-scroll-inner').css('height','100%');
                $('body').attr( 'data-pos', $(window).scrollTop()) ;
            }

        } else {
            if($(window).width() < 768 && util.isIOS() && $('.iosScrollStopper').length){
                $('.iosScrollStopper').removeClass('iosScrollStopper');
                $('.navigation-scroll-inner').css('height','100%');
                $( window ).scrollTop( $('body').attr( 'data-pos' ) );
            }
            resetMobileNav();
        }
    });

    // START - WCAG for hamburger button
    $("body").on("keyup", ".brands-header-active-mobile .hamburger-toggle button", function(e){
        e.preventDefault();
         if(e.keyCode === 13){
            var liveChat = $('.livechat-icon');
            var dynamicUrl = $('.dynamic-url').attr('data-href');            
            $('.slider-menu').addClass('modal-focus hamburger-keyboard');
            util.trapFocus($('.slider-menu.modal-focus.hamburger-keyboard'),function(){
                $('.slider-menu').removeClass('modal-focus hamburger-keyboard');
                resetMobileNav();
                $('.brands-header-active-mobile .hamburger-toggle button').focus().addClass('focus-outline');
            });
            $('.dynamic-url').attr('href', dynamicUrl); 
            if($(".livechat-icon .bcText a div").is(':empty')){
                liveChat.addClass('hide');
            } else{
                liveChat.removeClass('hide');
            }      
        }       
    });
   
    $("body").on("keyup", ".slider-menu .hamburger-toggle button", function(e){
        e.preventDefault();
        if(e.keyCode === 13){
            $('.slider-menu').removeClass('modal-focus hamburger-keyboard').removeAttr('tabindex');
            $('.dynamic-url').removeAttr('href');
            $('.brands-header-active-mobile .hamburger-toggle button').focus().addClass('focus-outline');
        }       
    });
    
    $("body").on("blur", ".modal-focus input, .modal-focus button, .modal-focus a", function(e){
        $('.modal-focus input, .modal-focus button, .modal-focus a').removeAttr('data-focussed');
        $(this).attr('data-focussed','true');
        setTimeout(function(){
            if($(document.activeElement).closest('.modal-focus').length == 0){
                var lastFocussed =  $('.modal-focus [data-focussed]');
                var childElems =  $('.modal-focus input, .modal-focus button, .modal-focus a');
                if(lastFocussed[0] !== childElems.eq(0)[0]){
                    childElems.eq(0).focus().addClass('focus-outline');                  
                } else{
                    childElems.eq(childElems.length -1).focus().addClass('focus-outline');
                }
            }
        }, 500);         
    });
    // END - WCAG for hamburger button

    $("body").on( "mousedown", ".top-banner", function(e){
        if($('.brands-header .hamburger-toggle').width() < 1 && $(e.target).closest('.slider-menu').length<1){
            $(this).addClass('click-start');
        }
    });
    $("body").on( "mousedown", ".slider-menu", function(){
        if($('.brands-header .hamburger-toggle').width() < 1) {
            $('.top-banner').removeClass('click-start');
        }
    });
    $("body").on( "click", ".top-banner", function(){
        if($('.brands-header .hamburger-toggle').width() < 1) {
            if($(this).hasClass('click-start')) {
                resetMobileNav();
            }
        } else {
            resetMobileNav();
        }
    });
    $("body").on( "click", ".slider-menu", function(e){
        e.stopPropagation();
    });

    function toggleRightPanel(target) {
        if(target == "none"){
            if(window.innerWidth < 768 && $(".right-panel-pane-search").hasClass("active")){
                $("html, body").scrollTop(0);
            }
            $('body').removeClass('right-panel-open');
            $('.has-active-panel').removeClass('has-active-panel');
            $(window).off("resize.rightPanel");
            $('body').off("click.rightPanel");
        } else {
            $('body').addClass('right-panel-open');
            $('.right-panel-pane.active').removeClass('active');
            target.addClass('active');
            var top = header.getRightPanelPlacement();
            var panelHeight = $(window).height()-top;
            $('.right-panel').css({top: top, height: panelHeight});
 
            if($(window).width() < 768){
                if(!$('body').hasClass('header-sticky-mobile')){
                    $('.right-panel').addClass('p-absolute');  
                }
                else{
                    $('.right-panel').removeClass('p-absolute');
                }
                
                if($("body").hasClass("header-mobile-menu-open")){
                    $('.right-panel').css({'height': panelHeight + $(window).scrollTop()});
                }
            }
 
            $(window).on("resize.rightPanel",(function() {
                var windowHeight = $(window).height();                              
                if(windowHeight > 300) {                    
                    var top = header.getRightPanelPlacement();
                    var panelHeight = windowHeight-top;
                    $('.right-panel').css({'top': top, 'height': panelHeight});
                    if($(window).width() < 768){
                        if($("body").hasClass("header-mobile-menu-open")){
                            $('.right-panel').css({'height': panelHeight + $(window).scrollTop()});
                        }
                        if(!$('body').hasClass('header-sticky-mobile')){
                            $('.right-panel').addClass('p-absolute');  
                        }
                        else{
                            $('.right-panel').removeClass('p-absolute');
                        }
                    }
                }
            }));
            $('body').on("click.rightPanel",(function(e) {
                if($(e.target).closest('.right-panel').length < 1){
                    if($('.right-panel-pane-login.active').length && $(e.target).closest('.ui-widget-overlay, .ui-dialog.ui-widget').length){
                        return;
                    }
                    toggleRightPanel('none');
                }
            }));            
        }
    }
    
    $("body").on( "click", ".header-search-util a", function(e){
        e.preventDefault();
        e.stopPropagation();
        if($(this).closest('li').hasClass('has-active-panel')){
            toggleRightPanel('none');
        } else {
            toggleRightPanel($('.right-panel-pane-search'));
            // only focus on input if click event fired from mouse, otherwise keyup will not fire for focus trapping.
            if(window.lastClickOrKey === 'click'){
                $('.right-panel-pane-search input[type="text"]').first().focus();
            }
            $('.header-search').addClass('focus');
            if($('.right-panel-pane-search input[type="text"]').first().val() !== '') {
                $('.right-panel-pane-search .close-icon').removeClass('hide-mobile');
            } 
            $('.has-active-panel').removeClass('has-active-panel');
            $(this).closest('li').addClass('has-active-panel');
        }
    });

    $("body").on( "click", ".secondary-account .account-btn, .cart-sign-in-cta ", function(e){
        $("input[name='loginFromCartCTA']").val("false");
        if($(this).closest('.mobile-menu-utilities').length > 0 && $('.user-panel.registered-user').length < 1) {
            return true;
        }
        else if($('.hamburger-toggle:visible').length && $(this).hasClass('cart-sign-in-cta') && $(window).innerWidth() < 768){
            return true;
        } else {
            e.preventDefault();
            e.stopPropagation();
            var createAccountBtn = $('.create-account-section').find("a[title='CREATE AN ACCOUNT']");
            var createAccountUrl = createAccountBtn.attr('href');
            if($(this).hasClass('cart-sign-in-cta')){
                $("input[name='loginFromCartCTA']").val("true");
                if(typeof(createAccountUrl) != 'undefined' && (createAccountUrl.indexOf('original') == -1)){
                    createAccountBtn.attr('href',createAccountUrl+"&original=/cart");
                }
            }else{
                if(typeof(createAccountUrl) != 'undefined' && (createAccountUrl.indexOf('original') != -1)){
                    createAccountBtn.attr('href',createAccountUrl.replace('&original=/cart',''));
                }
            }
            if($(this).closest('li').hasClass('has-active-panel')){
                toggleRightPanel('none');
            } else {
                toggleRightPanel($('.right-panel-pane-login'));
                $('.has-active-panel').removeClass('has-active-panel');
                $(this).closest('li').addClass('has-active-panel');
            }
        }
    });
    $("body").on( "click", ".my-account.heading a", function(e){
        if($('body').hasClass('header-mobile-menu-open')){
            e.preventDefault();
            e.stopPropagation();
            toggleRightPanel('none');
        }
    });
    
    $("body").on( "click", ".secondary-card a.flyout", function(e){
        e.preventDefault();
        e.stopPropagation();
        if($(this).closest('li').hasClass('has-active-panel')){
            toggleRightPanel('none');
        } else {         
            $('.has-active-panel').removeClass('has-active-panel');
            $(this).closest('li').addClass('has-active-panel');
     	   toggleRightPanel($('.right-panel-pane-card'));	
            var flyout = {
                event_name: "card_flyout",
                tealium_event: "link"
            };
            tealium.triggerEvent(flyout);
        }
    });
    $("body").on( "click", "a.card-promo-button-primary", function(e){
        var payMyBill = {
            event_name: "card_flyout_paymybill",
            tealium_event: "link"
        };
        tealium.triggerEvent(payMyBill);
    });

    //Tealium event for card flyout click apply
    $("body").on( "click", "a.card-promo-button-secondary", function(e){
        tealium.triggerEvent({event_name: "card_flyout_accept"});
    });

    var shoppingBagHoverTimeout;
    
    $("body").on( "click", ".secondary-header .shopping-bag-sm a, .navigation-cart .shopping-bag-sm a", function(e){
        var windowWidth = window.innerWidth;
        if (windowWidth < 1025 && windowWidth > 767 && is_touch_device()) {
            if($(this).closest('li').hasClass('has-active-panel')){
                toggleRightPanel('none');
                e.preventDefault();
                e.stopPropagation();
            } else if($('.brands-header .hamburger-toggle').width() > 0 && !$("#wrapper.pt_cart, #wrapper.pt_cart_template_b").length && $('.ucp2-cart-with-item-icon').length > 0) {
                toggleRightPanel($('.right-panel-pane-cart'));
                $('.has-active-panel').removeClass('has-active-panel');
                $(this).closest('li').addClass('has-active-panel');
                e.preventDefault();
                e.stopPropagation();
            }
        }
    });    
    
    $("body").on( "mouseenter", ".secondary-header .shopping-bag-sm a, .navigation-cart .shopping-bag-sm a", function(e){
        if(window.innerWidth > 767 && !$("#wrapper.pt_cart").length && !$("#wrapper.pt_cart_template_b").length && $('.ucp2-cart-with-item-icon').length > 0) {
            clearTimeout(shoppingBagHoverTimeout);
            toggleRightPanel($('.right-panel-pane-cart'));
            $('.has-active-panel').removeClass('has-active-panel');
            $(this).closest('li').addClass('has-active-panel');
        }
    });

    $("body").on( "mouseleave", ".secondary-header .shopping-bag-sm a, .navigation-cart .shopping-bag-sm a", function(e){
        if(window.innerWidth > 767 ) {
            shoppingBagHoverTimeout = setTimeout(function(){
                if($('.right-panel-pane-cart').hasClass('active')) {
                    toggleRightPanel('none');
                }
            }, 100);
        }
    });

    $("body").on( "mouseleave", ".right-panel-inner", function(e){
        if(window.innerWidth > 767  && $('.right-panel-pane.right-panel-pane-cart.active').length > 0) {
            shoppingBagHoverTimeout = setTimeout(function(){
                toggleRightPanel('none');
            }, 100);
        }
    });

    $("body").on( "mouseenter", ".right-panel-inner", function(e){
        clearTimeout(shoppingBagHoverTimeout);
    });
    $("body").on( "mousedown", ".right-panel", function(e){
        if($(e.target).closest('.right-panel-inner').length<1){
            $(this).addClass('click-start');
        }
    });
    $("body").on( "mousedown", ".right-panel-inner", function(){
        $('.top-banner').removeClass('click-start');
    });
    $("body").on( "click", ".right-panel.click-start", function(){
       toggleRightPanel('none');
    });
    $("body").on( "click", ".right-panel-inner", function(e){
        e.stopPropagation();
    });

    // START - Navigation - Category focus should open submenu via keyboard - WCAG - on focus
    $('#navigation .level-1 > li > a').off('focus').on('focus', function () {
        if ($(window).width() > 1023) {
            $(this).closest('li').siblings('li').addClass('notHover').removeClass('hoverIntent');
            $(this).closest('li').removeClass('notHover').trigger('hover').find('.level-2').addClass('open');
        }
    });
    
    $(document).on('keyup', function(e){    
        if ($(window).width() > 1023 && $(document.activeElement).closest('.menu-category').length === 0) {
            $(".menu-category .level-2, .menu-category > li").removeClass('notHover').removeClass('hoverIntent').removeClass('open');
        }
    });

    $(document).on('keyup','.menu-category .level-2 ul li a', function(e){
        var $this = $(this);
        if(window.innerWidth > 1023 && e.keyCode === 9 && $this.closest('.level-2').find('li:visible').first()[0] === $this.closest('li')[0]){
            util.trapFocus($($this.closest('.level-2')), function(){
                $(".menu-category .level-2, .menu-category > li").removeClass('notHover').removeClass('hoverIntent').removeClass('open');
                $this.closest('.level-2').closest('li').find('a').first().focus().addClass('focus-outline').attr('aria-expanded','false');
            });
        }
    })
    // END - WCAG focus

    $("body").on( "click", ".has-sub-menu", function(e){
        var isTouchEvent = $(this).attr("data-event-from-touch-device") === "true";
        if($(window).width() > 1023 && $(this).attr("data-event-from-touch-device") === "true"){
            e.preventDefault();
            $(this).removeAttr("data-event-from-touch-device");            
        }

        if(!$(this).closest('.header-mobile-menu-open').length && (window.lastClickOrKey === 'key' || isTouchEvent) && !$(this).closest('li.hoverIntent').length){
            e.preventDefault();
            $(this).attr('aria-expanded','true');
            $(this).closest('li').addClass('hoverIntent');
        }
    	else if($(this).closest('.header-mobile-menu-open').length > 0 && ($(this).closest('.swim-suit').length > 0 || $(this).closest('.swim-all').length > 0) ) {
    		$(this).parent('li').toggleClass('slideDown');
    		$(this).siblings().toggleClass('showContent');
    		e.preventDefault();
    		$('.has-sub-menu-level2-heading').off('click').on('click', function(ev){
    			ev.preventDefault();
    		});
    		}
    	else if($(this).closest('.header-mobile-menu-open').length > 0){
    			if($(this).closest('li').hasClass('l2-activate') || $(this).closest('li').hasClass('l2-active')) {
    				$('.l2-activate').removeClass('l2-activate');
    				$('.l2-active').removeClass('l2-active');
    				$('#header .menu-category').removeClass('header-mobile-menu-l2-open');
	    	 	} else {
	    				$('#header .menu-category').children().addClass('l2-disabled');
	    				$(this).closest('li').addClass('l2-activate').removeClass('l2-disabled');
	    				setTimeout(function(){
	    					$('.l2-activate').addClass('l2-active');
	    		        }, 20);
	    				$('#header .menu-category').addClass('header-mobile-menu-l2-open');
	    		}
    			e.preventDefault();	
    }
    });
    $("body").on( "click", ".has-sub-menu-level2-heading", function(e){
        if($(this).closest('.header-mobile-menu-open').length > 0) {
            e.preventDefault();
            if($(this).closest('.l3-activate').length > 0 || $(this).closest('.l3-active').length > 0) {
                $(this).closest('.l3-activate').addClass('l2-activate');
                setTimeout(function(){
                    $('.l2-activate').addClass('l2-active');
                }, 5);
                $('.l3-activate').removeClass('l3-activate');
                $('.l3-active').removeClass('l3-active');
                $('.l3-active-child').removeClass('l3-active-child');
                $('.l4-active').removeClass('l4-active');
                
                $('#header .menu-category').removeClass('header-mobile-menu-l3-open');
            } else {
               $(this).closest('.has-sub-menu-parent-level3').addClass('l3-active');
               $(this).closest('.l2-active').removeClass('l2-activate').removeClass('l2-active').addClass('l3-activate');
               $(this).closest('.has-sub-menu-parent-level3').addClass('l3-active-child');
                setTimeout(function(){
                    $('.l3-activate').addClass('l3-active');
                }, 20);
                $('#header .menu-category').addClass('header-mobile-menu-l3-open');
            }
            
        }
    });

    // handle last parent level in hamburger menu
    $("body").on( "click", ".has-sub-menu-level3", function(e){
            if($(this).closest('.header-mobile-menu-open').length > 0) {
                e.preventDefault();
                if($(this).closest('.l4-active-child').length > 0) {
                    $(this).closest('.l4-activate').addClass('l3-active').removeClass('l4-activate').removeClass('l4-active');
                    $(this).closest('li.parent-level3').removeClass('l4-active-child');
                    $('#header .menu-category').removeClass('header-mobile-menu-l4-open');
                } else {
                    $(this).closest('.l3-active').removeClass('l3-active').addClass('l4-activate');
                    $(this).closest('li.parent-level3').addClass('l4-active-child'); //added
                    setTimeout(function(){
                        $('.l4-activate').addClass('l4-active');
                    }, 20);
                    $('#header .menu-category').addClass('header-mobile-menu-l4-open');
                }
                
            }
        });
    
    //WCAG - Mini Cart flyout
    $("body").on("keyup", ".shopping-bag-sm .header-util-btn > a", function(e){
        if(e.keyCode === 13){
             e.preventDefault();
             $('.right-panel-pane-login.active').find('a').first().focus().addClass('focus-outline');           
    	}
    });
   
    util.inputfocusEvent();
    util.updateValue();
    util.copyClipboard();
    util.questionAndAnwserEvent();
    $(document).on('click', '.inventory select, .variant-dropdown select', function (e) {
        $(this).closest('.inventory').toggleClass('open');
    }).on('blur', '.inventory select', function (e) {
        $(this).closest('.inventory').removeClass('open');
    });

    $(document).on('click', '.variant-dropdown select', function (e) {
        $(this).closest('.variant-dropdown').toggleClass('open');
    }).on('blur', '.variant-dropdown select', function (e) {
        $(this).closest('.variant-dropdown').removeClass('open');
    });

    // show-hide password
    $("body").on( "click", "button.pwd-show", function(){
        var change = '';
        if ($(this).html() === 'Show') {
            $(this).html('Hide');
            $(this).closest('.field-wrapper').find($('input')).attr('type', 'text');
        } else {
            $(this).html('Show');
            change = 'password';
            $(this).closest('.field-wrapper').find($('input')).attr('type', 'password');
        }
    });
    
    //Generic popup component code for email
    $('body').off('click','.email-list-checkbox input[type="checkbox"]').on('click','.email-list-checkbox input[type="checkbox"]', function (){
        var $popUpContent=$(this).closest('form').find('.add-to-emaillist-warningmsg');
        if(this.checked){
            $popUpContent.addClass('tooltip-hidden');
            $popUpContent.closest('.content-asset').removeClass('email-container-block');
        }
        else{
            $popUpContent.removeClass('tooltip-hidden');
            $popUpContent.closest('.content-asset').addClass('email-container-block');
            if( typeof(utag_data) != 'undefined' && !hasSeenRebuttalMessage){
                var obj = {};
                obj.event_name = "email_subscription_rebuttal";
                tealium.triggerViewEvent(obj);
                hasSeenRebuttalMessage = true;
            }
        }
    });


    //wishlist email ajax
    $(document).on('click', '#SendToFriendForm button', function (e) {
        e.preventDefault();

        var $form = $('#SendToFriendForm');
        //add the value of the button being clicked
        if (this.name) {
            $form.append($('<input type="hidden" />').attr({
                name: this.name,
                value: this.value
            }));
        }
        var sendToFormUrl = $form.attr('action');

        if ($form.valid()) {
            ajax.getJson({
                url: sendToFormUrl,
                data: $form.serialize(),
                method: 'POST',
                callback: function (result) {
                    if (result == "OK") {
                        $form.closest('.sendtofriend').hide();
                        $('.sendtofriend-success').show();
                        /* WCAG_Modal_focus_management */
                    	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                        	$(this).focus();
                        });
                        $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                    } else {
                        $form.closest('.sendtofriend').hide();
                        $('.sendtofriend-error').show();
                    }
                }
            });
        }
        return false;
    });
    if($("form.email-signup-footer-form").length){
        $('form.email-signup-footer-form').on('submit', function (e) {
            e.preventDefault();

            var $form = $(this);
            var emailSignupUrl = $form.attr('action');

            if ($form.valid()) {
                //reset messaging
                $('.email-signup-footer-success').hide();
                $('.email-signup-footer-error').hide();
                $('.email-signup-footer-success-international').hide();

                ajax.getJson({
                    url: emailSignupUrl,
                    data: $form.serialize(),
                    method: 'POST',
                    callback: function (result) {
                        if (result && result.success) {
                            if(result.showMessageForRestirctedCountries){
                                $('.email-signup-footer-success-international').show().closest('.footer-container').addClass('success-message');
                            }else{
                                $('.email-signup-footer-success').show().closest('.footer-container').addClass('success-message');
                            }
                            var $canfocus = $('body').find(':focusable');
                            var index = $canfocus.index($('.email-signup-footer-form button:visible')) + 1;
                            if (index >= $canfocus.length) index = 0;
                            $('.email-signup-footer-form').hide();
                            if(window.lastClickOrKey === 'key') $canfocus.eq(index).focus().addClass('focus-outline');
                            var optInOutLocation = "Footer Sign Up";
                            if (typeof window.location.pathname != 'undefined' && window.location.pathname === "/platinum-card") {
                                optInOutLocation = "PLCC Learn More";
                            }
                            var obj = {
                                event_name: "email_registration",
                                deal_opt_in_out_location: optInOutLocation
                            };
                            tealium.triggerEvent(obj);
                        } else {
                            $('.email-signup-footer-error').show();
                        }
                    }
                });
            }
            return false;
        });
    }
    $("body").on( "click", "#loginFlyout", function(e){
        $(window).unbind('message').bind('message', function (e) {
            var resdata;
            e = e.originalEvent;
            if (e.origin.indexOf(document.location.host) === -1) {
                return;
            }
            var obj = e.data;
            resdata = JSON.parse(obj);
            if (!resdata.login && resdata.passwordreset && resdata.resetURL) {
                window.location.href = resdata.resetURL;
            } else if (resdata.login && resdata.success) {
                $('.serverSide-errorMessage').hide();
                var obj = {
                    event_name: "login-success"
                };
                tealium.triggerEvent(obj);
                if (resdata.redirectToCart){
                    window.location.href = Urls.cartShow;                	
                } else if (SitePreferences.LOGIN_REDIRECT) {
                    window.location.href = SitePreferences.LOGIN_REDIRECT;
                } else {
                	window.location.href = Urls.logInRedirect;
                }
            } else {
            	var lengthError = false;
            	if (resdata.passwordlengthvalid == true && resdata.customerFound == false) {
            		$('.serverSide-errorMessage.text').show();
            	} else {
            		lengthError = true;
            		$('.serverSide-errorMessage-length').show();
            	}
                var obj = {
                    event_name: "login-failure"
                };
                tealium.triggerEvent(obj);
                window.location.href = Urls.logIn + "?error=true&lengthError="+lengthError;
            }
        });
    });

    $(document).on('click', 'a.js-gift-card-balance', function (e) {
        e.preventDefault();
        var gcBalanceCheck = Urls.giftCardBalanceCheck;
        dialog.open({
            url: gcBalanceCheck,
            options: {
                dialogClass: 'gc-checkbalance',
                width: 500,
                open: function () {
                    validator.init();
                    //closing on overlay click
                    $('.ui-widget-overlay').on('click', function (e) {
                        if ($('.gc-checkbalance').is(':visible')) {
                            $('.gc-checkbalance').find('.ui-dialog-titlebar-close').trigger('click');
                        }
                    });
                    /* PXSFCC-4495_WCAG_Modal_focus_management */
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter", function () {
                        $(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                }
            }
        });
    });

    $(document).on('click', '.js-gc-check-submit', function (e) {
        e.preventDefault();
        var $gcForm = $('.gift-card-form');
        var gcForm = document.querySelector('.gift-card-form');
        $('.gc-show-message').text('');
        if (!$gcForm.valid()) {
            return false;
        }
        var form = new FormData(gcForm);
        var url = util.appendParamToURL($gcForm.attr('action'), 'format', 'ajax');
        var applyName = $(this).attr('name');
        ajax.fetchData({
            url: url,
            method: 'POST',
            data: form,
            callback: function (result) {
                $('.gc-show-message').text('');
                if (!result) {
                    $('.gc-show-message').html(Resources.GC_ERROR);
                    return false;
                } else {
                    $('.gc-show-message').html(result.message);
                }
            }
        });
    });

    //print page for order confirmation
    if($('.print-page').length){
        $('.print-page').on('click', function () {
            window.print();
            return false;
        });
    }

    //shipping overlay for order confirmation
    if ($('#wrapper').hasClass('pt_order-confirmation') || $('#wrapper').hasClass('pt_order')) {
        $(document).on('click', '.shippingoverlay-link', function (e) {
            e.preventDefault();
            var shippingoverlay = $('#shipping-overlay').html();
            dialog.open({
                html: shippingoverlay,
                options: {
                    width: 365,
                    dialogClass: 'shipping-overlay',
                    title: Resources.SHIPPING_OVERLAY_TITLE
                }
            });
        });
    }

    //add to personal message PDP
    util.selectbox();

    // PLCC landing page tab selection
    var plccTabOffset = -30,
        headerPrevAttr = $('#header').prevAll().outerHeight();
    if($(".benefits-tab").length){    
        $(".benefits-tab").on('click', function () {
            $(this).addClass('active');
            $('.rewards-tab').removeClass('active');
            $('.faqs-tab').removeClass('active');
            $('.platinumperk-tab').removeClass('active');
            $('html, body').scrollTop(0).animate({
                'scrollTop': $(".plcc-top-content").find('.benefits').offset().top - $('.header_fixed').find('.fixed-header').outerHeight() - headerPrevAttr + plccTabOffset
            }, 700);
        });
    }
    if($(".rewards-tab").length){
        $(".rewards-tab").on('click', function () {
            $(this).addClass('active');
            $('.benefits-tab').removeClass('active');
            $('.faqs-tab').removeClass('active');
            $('.platinumperk-tab').removeClass('active');
            $('html, body').scrollTop(0).animate({
                'scrollTop': $(".plcc-top").find('.rewards .circle').offset().top - $('.header_fixed').find('.fixed-header').outerHeight() - headerPrevAttr + plccTabOffset
            }, 700);
        });
    }
    if($(".faqs-tab").length){
        $(".faqs-tab").on('click', function () {
            $(this).addClass('active');
            $('.benefits-tab').removeClass('active');
            $('.rewards-tab').removeClass('active');
            $('.platinumperk-tab').removeClass('active');
            $('html, body').scrollTop(0).animate({
                'scrollTop': $(".plcc-bottom").find('.qa-content').first().offset().top - $('.header_fixed').find('.fixed-header').outerHeight() - headerPrevAttr + plccTabOffset
            }, 700);
        });
    }
    if($(".platinumperk-tab").length){
        $(".platinumperk-tab").on('click', function () {
            $(this).addClass('active');
            $('.benefits-tab').removeClass('active');
            $('.rewards-tab').removeClass('active');
            $('.faqs-tab').removeClass('active');
            $('html, body').scrollTop(0).animate({
                'scrollTop': $(".perks-email-wrapper").first().offset().top - $('.header_fixed').find('.fixed-header').outerHeight() - headerPrevAttr + plccTabOffset
            }, 700);
        });
    }
    // on tabbing on Selectbox, makes active and open
    if ($(window).width() > 1024) {
    	var lastClickFocus = '';
        $(document).on('mousedown', '.custom-select', function (e) {
        	lastClickFocus = e.target;
        }).on('focus', '.custom-select', function (e) {
        	if (e.target == lastClickFocus) {
        		return;
    	    }
        	lastClickFocus = '';
        }).on('blur', '.custom-select', function (e) {
            if ($(this).hasClass('current_item')) {
                $(this).find('.selected-option').trigger('click');
            }
            //removes focus class on label
            var $curFormRow = $(this).closest(".form-row");
            var $curLabel = $curFormRow.find("label");
            if ($curFormRow.hasClass("error-handle")) {
                var value = $(this).val();
                if (value.length == 0) {
                    $curLabel.removeClass("input-focus");
                }
            }
        });
    }

    // suppress focus indicator on anchor click
    $('body').on('mousedown mouseup', 'a', function (e) {
        $(this).css({"outline": "none", "box-shadow": "none"});
    });
    
    $('body').off('input','#PasswordResetForm input.resetemail').on('input','#PasswordResetForm input.resetemail', function (e) {
            $('.reset-error-caption.invalid-email').addClass('hide');
            $('.reset-error-caption:not(.invalid-email)').addClass('hide');
            validator.settings.errorClear(this);
    });

    // add a focus class when key has entered
    $('body').on('keyup','a, button, select, input,[tabindex="0"],textarea',function(e){
    	if (e.which == 9) {
    		$(this).addClass("focus-outline");
    	}
    	// add a focus class when radio button selected by arrow keys For SC-1531
        if (e.which == 9 || e.which == 37  || e.which == 38  || e.which == 39  || e.which == 40 ) {
        	// remove a focus class when radio button selection change by arrow keys For SC-1531 
        	if($(this).siblings("span").hasClass("custom-radio-icon")){
          	  $(this).siblings("span").addClass("focus-outline");
            }
        }
    }).on('blur','a, button, select, input,[tabindex="0"],textarea',function(e){
        $(this).removeClass("focus-outline");
        if($(this).siblings("span").hasClass("custom-radio-icon")){
       	  $(this).siblings("span").removeClass("focus-outline");
         }
    });

    // add a focus class for custom select box
    $('body').on('keyup','.custom-select select',function(){
        $(this).closest('.custom-select').addClass("focus-outline");
        $(this).removeAttr('style');
    }).on('blur','.custom-select select',function(){
        $(this).closest('.custom-select').removeClass("focus-outline");
    }).on('focus','.custom-select select',function(){
        if(window.lastClickOrKey === 'key'){
            $(this).closest('.custom-select').addClass("focus-outline");
        }        
    });

    //On change of payment card type in billing/account page
    $(document).on('change', '.form-row.type select', function () {
        var currentselect = $(this);
        util.paymentcardselection(currentselect);
    });

    // //function to inject brand logos for slider navigation
    // if ($(window).width() <= 1023) {
    //     var url = Urls.includebrandlogos;
    //     var target = $('.load-logos-for-mobile');
    //     $.ajax({
    //         url: url,
    //         method: 'GET',
    //         success: function (data) {
    //             if (target != null)
    //                 target.html(data);
    //         }
    //     });
    // }; Removing this legacy function to clean logs: AZ-20052

    // Add toggle functionality for Promo Code in Billing Page and Cart page
    $(document).on('click', '.auto-gift-outofstock-details .see-details', function (e) {
        e.preventDefault();
        $(this).closest('.item-details').find('.discount-details').toggle();
        if (!$(this).hasClass('opened')) {
            $(this).addClass('opened').text('Hide Details');
        } else {
            $(this).removeClass('opened').text('See Details');
        }
    });

    //Add toggle functionality for Promo Code in Cart page
    $(document).on('click', '.discount-item-details .see-details', function (e) {
        e.preventDefault();
        var discountItemDetails = $(this).closest('.item-details').find('.discount-item-details');
        $(this).closest('.item-details').find('.discount-details').toggle();
        if (!$(this).hasClass('opened')) {
            $(this).addClass('opened').text('Close Details').addClass('details-remove-swap');
            if(discountItemDetails.find('.not-applied').hasClass('promo-codes-apply-notapply') || discountItemDetails.find('.promo-applied').hasClass('promo-codes-apply-notapply')){
            	discountItemDetails.find('.promo-codes-apply-notapply').hide();
            }
            $(this).closest('.item-details').find('.textbutton').addClass('remove-details-swap');
            if(discountItemDetails.hasClass('no-calloutmsg')){
            	discountItemDetails.css('height','auto');
            }
        } else {
            $(this).removeClass('opened').text('Details').removeClass('details-remove-swap');
            if(discountItemDetails.find('.not-applied').hasClass('promo-codes-apply-notapply') || discountItemDetails.find('.promo-applied').hasClass('promo-codes-apply-notapply')){
            	discountItemDetails.find('.promo-codes-apply-notapply').show();
            }
            $(this).closest('.item-details').find('.textbutton').removeClass('remove-details-swap');
            if(discountItemDetails.hasClass('no-calloutmsg')){
            	discountItemDetails.css('height','20px');
            }
        }
    });
    
    //added onchange to ensure that value in dropdown will be displeyd right after selection
    //bug was that value was not present until use clicks somewhere else on the page
    $('.input-select').on("change", function () {
        var r = $(this).closest(".form-row");
        r.addClass("show-text");
    });

    // poll for input chagnes periodically. needed b/c there is no standard cross-browser event that fires when autofilling/autocorrecting occurs
    if (!$('#wrapper').hasClass('pt_checkout')) {
        window.setInterval(function () {
            util.adjustForAutofill();
        }, 200);
    }

    //gallery dialog model need to move to BM
    window.onload = function(){
        if($('#gallery-term-condition').length){
            $('#gallery-term-condition').dialog({
                width: 800,
                height: 500,
                modal: true,
                autoOpen: false,
                close: function () {
                    $(this).dialog('close');
                    location.hash = "";
                },
            });

            $('#gallery-term-condition .close, .ui-widget-overlay').click(function(){
                $('#gallery-term-condition').dialog('close');
            });

            if (location.hash.toLowerCase().indexOf('gallery-term-condition') != -1){
                $('#gallery-term-condition').dialog('open');
            }
            $('.gallery-dialog-open').click(function(){
                $('#gallery-term-condition').dialog('open');
            }).show();
        }
    };

    var imagesLoaded = require('imagesloaded');
    imagesLoaded('.recommendation-tiles').on('always', function() {
    	util.pdpSlickSlider();
    });
    util.proset_SlickSlider();
    util.completeTheLook_SlickSlider();

    //handle varvar new tab links
    if(SitePreferences.NARVAR_RETURNS_ENABLED && !SessionAttributes.IS_CUSTOMER_AUTHENTICATED){
        //find link by class and add target _blank attrubute
        $('.returnLink').attr('target', '_blank');
    }
    
    //Clearing the error message to submit the form
    $('body').off('input','.login-form input').on('input','.login-form input',function(){
    	validator.settings.errorClear(this);
    });
    
    //SC-2773 City field for shipping billing and my account page does not exceed 13 chars on focus
    $('body').off('focus','input[name$="_shippingAddress_addressFields_city"] , input[name$="_billingAddress_addressFields_city"] , input[name$="_profile_address_city"]').on('keyup','input[name$="_shippingAddress_addressFields_city"] , input[name$="_billingAddress_addressFields_city"] , input[name$="_profile_address_city"]', function (e){
    	e.preventDefault();
    	$(this).attr("maxlength","13");
    	if (this.value.length > 13)         
    		this.value = this.value.slice(0,13);
    });
    $('body').off('blur','input[name$="_shippingAddress_addressFields_city"] , input[name$="_billingAddress_addressFields_city"] , input[name$="_profile_address_city"]').on('blur','input[name$="_shippingAddress_addressFields_city"] , input[name$="_billingAddress_addressFields_city"] , input[name$="_profile_address_city"]', function (e){
    	e.preventDefault();
        $(this).attr("maxlength","50");
    });
    
    //Password Status Validation 
    util.passwordStatusValidation();
    
    window.util = util;
    window.imagesLoaded = imagesLoaded;

    // Header-redesign-grv-code starts
    $('.secondary-header>ul>li[data-isoverlay="yes"][data-overlay-on-click="yes"]').click(function (e) { 
        // ($(window).width() > 767 || ($(window).width() <= 767 && SessionAttributes.IS_CUSTOMER_AUTHENTICATED)) && $('.sticky-header').length == 0
    	if($(window).width() < 768  && e.currentTarget.classList.contains('secondary-account') && !SessionAttributes.IS_CUSTOMER_AUTHENTICATED){
            return;
        }
            e.preventDefault();
            if($('.secondary-header ul li.active').length){ 
                // call analytics
                // fly-overlay-search
                var overlayName = $(this).attr('data-overlayname');
                    if (typeof overlayName != 'undefined' && overlayName.length > 0) {
                    var obj = {
                        event_name: overlayName.replace('fly-overlay-', '') + '_flyout'
                    };
                    tealium.triggerEvent(obj);
                }
            }
    });

    // Header-redesign-grv-code ends

    // START - WCAG - To speak letters for applied promo code
    $('body').on('change', '.coupon-code', function (e) {
        e.preventDefault();
        var couponValue = $(this).val().split('').join(' ');
        $(this).attr('aria-label', couponValue);
    });

    $('.rowcoupons .cartcoupon .value').each(function() {
        var promoValue= $(this).text().split('').join(' ');
        $(this).attr('aria-label', promoValue);
    });
    // END - WCAG - To speak letters for applied promo code

    // WCAG - Appending id on role tooltip on focus - generating runtime unique id
    $("body").on("focus", ".promotion-callout .tooltip", function (e) {
        e.preventDefault();     
        setTimeout(function(){
            var tooltipId = $(".promotion-callout .tooltip.focus-outline").attr("aria-describedby");
            $('.focus-outline .tooltip-content').attr('id', tooltipId);
        }, 500);
    });
    if($('#intl-copyright-year')){        
        $('#intl-copyright-year').html(new Date().getFullYear());
    }
    
    if($('.intl-exclusion-modal').length && !$('.intl-exclusion-modal').hasClass('hide')){
        internationalShipping.internationalProductExculsionModalEvents();
    };
    if(window.SessionAttributes != null && !window.SessionAttributes.HAS_GEWELCOME_COOKIE){
        updateGEWelcomeStatus();
    }
}


function updateGEWelcomeStatus() {
    
    var globaleCookie = util.getCookie('GlobalE_Data').length ? JSON.parse(decodeURIComponent(util.getCookie('GlobalE_Data'))) : '';
    var globaleCookieCountry = globaleCookie && globaleCookie.countryISO;
    if(globaleCookieCountry && globaleCookieCountry == "US") return;

    if(!util.getCookie('GlobalE_Welcome_Data').length) return setTimeout(updateGEWelcomeStatus, 50); 

    var urlValue = Urls.checkGEWelcomeCookie;
    $.ajax({
        url: urlValue,
        method: 'GET',
        success: function success(data) {
            return "session.custom['hasGEWelcomeCookie'] "+data;
        }
    });
}

/**
 * @private
 * @function
 * @description utility method for merchandising. Storing values in cookie temporarily
 */
var merchutils = function () {

    this.getCookie = function (cookieName) {
        var myObject = util.getCookie(cookieName);
        return myObject
    }

    this.setCookie = function (cookieName, merchandising) {
        util.createCookie(cookieName, merchandising);
    }

    this.getProductCookie = function (cookieName, productID) {
        var myObject = util.getCookie(cookieName);
        if (typeof myObject == 'string') {
            myObject = JSON.parse(myObject);
        }
        if (typeof myObject == 'object' && myObject[productID] != undefined) {
            return myObject[productID];
        }
    }

    this.setProductCookie = function (cookieName, productID, merchandising) {
        var myObject = util.getCookie(cookieName);
        if (typeof myObject == 'object') {
            myObject = util.getCookie(cookieName)
        } else if (!myObject) {
            myObject = {};
        } else {
            myObject = JSON.parse(util.getCookie(cookieName))
        }
        myObject[productID] = merchandising;
        util.createCookie(cookieName, JSON.stringify(myObject));
    }

    this.setProductFindingMethodCookie =  function(value){
    	var siteId=currentSite.id;
        /** set the max age for cookie to 3 days**/
        util.createCookie('_productFindingMethodOSS', value,3);
    }
    
    this.setProductAddToCartCookie = function (cookieName, productID, merchandising) {
      var myObject = util.getCookie(cookieName);
      if (typeof myObject == 'object') {
          myObject = util.getCookie(cookieName);
      } else if (!myObject) {
          myObject = {};
      } else {
          myObject = JSON.parse(decodeURIComponent(util.getCookie(cookieName)));
      }
      if(typeof myObject[productID] === 'undefined'){
          myObject[productID] = (merchandising !== '') ? merchandising : 'direct';
      }

      util.createCookie(cookieName, encodeURIComponent(JSON.stringify(myObject)));
  };
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js
 *              specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
    util.adjustForAutofill();
    window["MERCH_UTILS"] = new merchutils();
    //load polifill
    webshim.polyfill("sticky");
}
//display custom tooltip on icon hover for all sites
$("body").on("mouseover", ".b_product_icon", function () {
    $(this).next(".stickerToolTip").show();
    $(this).nextAll().eq(1).addClass('hoverQuickView');
}).on("mouseout", ".b_product_icon", function () {
    $(this).next(".stickerToolTip").hide();
    $(this).nextAll().eq(1).removeClass('hoverQuickView');
});

$('.b_product_icon').on('click', function (e) {
    e.preventDefault();
}); 

var creditScript = '';
if(SitePreferences.PLCCPRESCREENREDESIGN_ENABLED) {
	creditScript = require('./pages/credit_plcc_redesign');
} else{
	creditScript = require('./pages/credit');
}
var pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    compare: require('./pages/compare'),
    credit: creditScript,
    customerservice: require('./pages/customerservice'),
    offerscoupons: require('./pages/offerscoupons'),
    product: require('./pages/product'),
    registry: require('./pages/registry'),
    search: require('./pages/search'),
    storefront: require('./pages/storefront'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator'),
    mixandmatch: require('./pages/mixandmatch'),
    orderconfirmation: require("./pages/checkout/orderconfirmation")
};

var hoverIntentObject = require('./hoverIntent');

var blackBarNav = {
    parentContainer: '.fixed-header',
    mainElement: "#main ,.menu-utility-user .info , .menu-utility-user .mini-cart-total, .menu-utility-user .mini-cart-content,  .menu-utility-user .user-panel, .menu-utility-user .mini-cart-products, .header-main-search .header-offers, .header-main-search .offer-flyout, .header-main-search .offers-flyout-banner, .header-main-search .offers-flyout-banner a, .header-main-search .link-on-image",
    classes: {
        active: 'DelayHover',
        parentClass: ['info', 'header-offers'],
        subMenuClass: ['mini-cart-total']
    },
    pauseAreas: 'input,fieldset',
    id: 'id'
},

menuObjHover = {
    main: '#navigation',
    sub: 'a.has-sub-menu',
    class: 'hoverIntent',
    siblingsClass: 'notHover',
    mouseNumber: {
        dividend: 1000,
        divisor: 400
    },
    intervalNumber: 5
};

var menuHoverFunction = new hoverIntentObject.MainMenu(menuObjHover),
    delayedMenuHoverMedthod = new hoverIntentObject.customeMenu(blackBarNav);

    var boldChatAddonScript = {
        init:function(){
            var div_in_body = document.querySelector('span.chat-contact');
            if (div_in_body !== null) { div_in_body.appendChild(customer_service_text); }
            else { return false; }
        }
    }

var mobileMenuLoad=function (){
    var customHamMenuURL = Urls.customHamMenuURL,
        $target = $('.custom-megamenu');        

    ajax.load({
        url: customHamMenuURL,
        target : $target,
        callback : function(response){
            if(response.length){
                $target.attr('data-menu-loaded',true);
            }
        }
    });
};

var app = {
    init: function () {
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append(
                $('<p/>').addClass('browser-error').html(
                    Resources.COOKIES_DISABLED)).appendTo(
                '#browser-check');
        }
        initializeDom();
        initializeEvents();

        // init specific global components
        header.init();
        countries.init();
        tooltip.init();
        minicart.init();
        validator.init();
        rating.init();
        login.init();
        lookbook.init();
        searchplaceholder.init();
        contentAssetHelper.initContentAssets();
        // Global forms
        formFields.init();

        // execute page specific initializations
        $.extend(page, window.pageContext);
        var ns = page.ns;
        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }
        if (SitePreferences.TEALIUM_ENABLED) {
            require('../../../int_tealium/cartridge/js/tealium/init').init();
        }
        // call center recording integration
        var csrExtension = util.getCookie("csr_extension");
        if (csrExtension.length > 0) {
            if (SitePreferences.GENESYS_ENABLED) {
                require('../../../int_genesys/cartridge/js/genesys/init').init(csrExtension);
            }
            if (SitePreferences.VERINT_ENABLED) {
                require('../../../int_verint/cartridge/js/verint/init').init(csrExtension);
            }
        }
        if ($(".breadcrumb").length > 0 && $(window).width() > 767) {
            if ($(".breadcrumb").find("*:visible").last().attr("href") == "javascript:void(0);") {
                $(".breadcrumb").find("*:visible").last().trigger("click");
            }
        }

        // apply hoverIntent to page
        menuHoverFunction.setup();
        delayedMenuHoverMedthod.setup();
        newMegaMenu($(".fixed-header").height(),false); //SC-3513 new mega menu calling

        //run boldChat script
        boldChatAddonScript.init();

        this.initLazyLoadImages();

        smsOptInModal.init();

    },
    checkImageForLazyLoad: function(imageElem){
        var imgObj = imageElem.getBoundingClientRect();
        return (imgObj.top >= 0 && imgObj.left >= 0 && imgObj.bottom <= (window.innerHeight || document.documentElement.clientHeight) && imgObj.right <= (window.innerWidth || document.documentElement.clientWidth));
    },
    initLazyLoadImages: function(){
        $("img[data-lazyloadsrc]").each(function(){
            if(app.checkImageForLazyLoad($(this)[0])){
                $(this).attr("src", $(this).attr("data-lazyloadsrc"));
                $(this).removeAttr("data-lazyloadsrc");
            }
        });
    }
};



// general extension functions
(function () {
    String.format = function () {
        var s = arguments[0];
        var i, len = arguments.length - 1;
        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();
//Close the mega menu on clicking outside the menu when the focus is on any level1 or level2 category SC-5154 
$('#wrapper').on('click', function (e) {
    if ( ($('#navigation li').hasClass('hoverIntent') ||  $('#navigation .level-1 .level-2').hasClass('hoverIntent')) && !$(e.target).hasClass('has-sub-menu') && $(window).width() > 1023 ){
         $('#navigation .level-1 .level-2, #navigation li').removeClass('hoverIntent'); 
         $(this).find('.level-2').removeClass('open'); 
    } 
});

function is_touch_device() {  
    try {  
      document.createEvent("TouchEvent");  
      return true;  
    } catch (e) {  
      return false;  
    }  
  }

    function newMegaMenu(heightVal,chk){
        var setMegamenuHeight= function(heightVal){
            var defaultHeight=325;
            var screenHeight=0;
            var $windowWidth= $(window).width();
            var $windowHeight= $(window).height();
            if($windowWidth > 767 && ($windowWidth < 1025 || is_touch_device())){
                screenHeight= $windowHeight - (heightVal+80); 
            }
            else{
                    screenHeight= $windowHeight - (heightVal);
            }
            if (($windowWidth > 767) && $("body").find("#navigation .menu-category.level-1 > li").find('.new-mega-menu')){
                    $( "#navigation .menu-category.level-1 > li a.has-sub-menu" ).each(function(){
                        $(this).parent().find('.new-menu').css({"max-height":screenHeight+"px","min-height":defaultHeight+"px","overflow-y":"scroll","-webkit-overflow-scrolling": "touch"});
                        //Line height Code between L3-L2 start
                        $(this).parent().find('.new-menu').find('ul.nav-column').find("li.only-L2-cat").each(function(){
                            var $this = $(this);
                            if(($this.prev("li.parent-level2").find("ul").hasClass("show-categories"))){               		
                                $this.prev("li.parent-level2").next("li.parent-level2").addClass("L2-cat-after-L3");
                            }
                            else{
                                $this.prev("li.parent-level2").next("li.parent-level2").removeClass("L2-cat-after-L3");
                                
                            }
                        });
                    //Line height Code between L3-L2 End                
                    });
            }
            else{
                $( "#navigation .menu-category.level-1 > li a.has-sub-menu" ).each(function(){
                    $(this).parent().find('.new-menu').removeAttr('style');
                });
            }
        }

        
        setMegamenuHeight(heightVal);
        $(window).resize(setMegamenuHeight.bind(this,heightVal));
    }

$("body").on("touchstart", " .parent-level2 a,.parent-level3 a,.parent-level4 a", function(e){
		if($(window).width() > 1023 && $(this).attr("href")){			
			e.preventDefault();
	             window.location = $(this).attr("href");
	         }
});

// Market place vender seller page :: SC-10514 - Radio Input required error message placement update		
$('body').on('click', '.marketplace-apply-btn', function (e) {
    setTimeout(function(){ 		
           var $venderTypeDiv =$("#marketPlaceVendorRegisterForm .vendor_type"),
            $venderTypeErrorDiv = $venderTypeDiv.find(".radio-input-block").find("span"),
            $vendorCategoryDiv =$("#marketPlaceVendorRegisterForm .vendor_main_category"),		
            $vendorCategoryErrorDiv= $vendorCategoryDiv.find(".radio-input-block").find("span"),
            venderTypeErrorDivCopy=  $venderTypeErrorDiv.text(),
            vendorCategoryErrorDivCopy=  $vendorCategoryErrorDiv.text(); 
           if($venderTypeErrorDiv.hasClass("error")) {
               $venderTypeErrorDiv.empty();
               $venderTypeDiv.append($venderTypeErrorDiv.text(venderTypeErrorDivCopy));
           }
           if($vendorCategoryErrorDiv.hasClass("error")){
               $vendorCategoryErrorDiv.empty();
               $vendorCategoryDiv.append($vendorCategoryErrorDiv.text(vendorCategoryErrorDivCopy));						
           }				
   }, 100);			
});

//PLCC Tealium Events: click 'accept now' on preapproved banners outside of checkout
var ctaClass = ' .accept-now';
var ctaSlots = ['.header-promo-bottom', '.footer-plcc', '.plcc-ov-left-section', '.plcc-top', '.plcc-bottom' ];
var locations = ['header', 'footer', 'my_account', 'credit_card_page', 'credit_card_page'];

function triggerTealium(location){
    tealium.triggerEvent({
        event_name: "plc_offer_accepted",
        event_location_plc: location
    });
};
ctaSlots.forEach((e,i)=>{
    $('body').off('click', e + ctaClass).on('click', e + ctaClass, function(){
        triggerTealium(locations[i]);
    });
});

$('.pt_checkout .item-details, .pt_cart_template_b .item-details').each(function(){
    var msgTxt = $(this).find(".specialmessaging p").text().toLowerCase()
    if(msgTxt === "physical plastic gift card" || msgTxt === "digital electronic gift card"){
        $(this).find(".specialmessag").addClass("gift-card")
    }
})

// initialize app
$(document).ready(function () {
    app.init();
});
